export default __webpack_public_path__ + "static/media/husqvarna.4b505549.png";